import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { NgxMatColorCanvasComponent } from '@portal-core/ui/color-picker/components/color-canvas/color-canvas.component';
import { NgxMatColorSliderComponent } from '@portal-core/ui/color-picker/components/color-canvas/color-slider/color-slider.component';
import { NgxMatColorCollectionComponent } from '@portal-core/ui/color-picker/components/color-collection/color-collection.component';
import { NgxMatColorPaletteComponent } from '@portal-core/ui/color-picker/components/color-palette/color-palette.component';
import { NgxMatColorPickerInput } from '@portal-core/ui/color-picker/components/color-picker/color-input.component';
import { NgxMatColorPickerComponent, NgxMatColorPickerContentComponent, NGX_MAT_COLOR_PICKER_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@portal-core/ui/color-picker/components/color-picker/color-picker.component';
import { NgxMatColorToggleComponent } from '@portal-core/ui/color-picker/components/color-toggle/color-toggle.component';
import { NumericColorInputDirective } from '@portal-core/ui/color-picker/directives/numeric-color-input.directive';
import { ColorAdapter } from '@portal-core/ui/color-picker/services/color-adapter';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { MCColorPickerComponent } from './color-picker.component';

@NgModule({
  declarations: [
    NgxMatColorPaletteComponent,
    NgxMatColorCanvasComponent,
    NgxMatColorCollectionComponent,
    NgxMatColorSliderComponent,
    NumericColorInputDirective,
    NgxMatColorPickerContentComponent,
    NgxMatColorPickerComponent,
    NgxMatColorToggleComponent,
    NgxMatColorPickerInput,
    MCColorPickerComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatCardModule,
    MatRadioModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    PortalModule,
    MatIconModule,
    FormControlErrorMessageModule,
  ],
  exports: [
    NgxMatColorToggleComponent,
    NgxMatColorPickerInput,
    NgxMatColorPickerComponent,
    MCColorPickerComponent
  ],
  entryComponents: [
    NgxMatColorPickerContentComponent
  ],
  providers: [
    ColorAdapter,
    NGX_MAT_COLOR_PICKER_SCROLL_STRATEGY_FACTORY_PROVIDER
  ]
})
export class MCColorPickerModule { }
